import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Component from "./component";
import { fetchAdsDetails } from "./action";

const mapStateToProps = ({
    locationPicker: { pageType }
}) => {
    return {
        pageType
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAdsDetailsConnect: fetchAdsDetails
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));
